import { useEffect, useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { fmtSqft, fmtMoney, fmtFolio } from "@/lib/permitcheck";
import { useLang } from "@/lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CompareDialog = ({ ids, open, onOpenChange }) => {
  const { t, lang } = useLang();
  const [reports, setReports] = useState([]);

  useEffect(() => {
    if (!open || ids.length !== 2) return;
    Promise.all(ids.map((id) => axios.get(`${API}/saved-reports/${id}`).then((r) => r.data)))
      .then(setReports)
      .catch(() => setReports([]));
  }, [open, ids]);

  const rows = [
    ["report.municipality", (r) => r.jurisdiction || "—"],
    ["sum.zoning", (r) => r.zoning || "—"],
    ["zon.futureLandUse", (r) => r.zoning_block?.future_land_use || "—"],
    ["rec.use", (r) => r.property_use || "—"],
    ["rec.landUse", (r) => r.land_use || "—"],
    ["rec.lot", (r) => fmtSqft(r.property_records?.lot_size, lang)],
    ["rec.year", (r) => r.property_records?.year_built || "—"],
    ["rec.assessed", (r) => fmtMoney(r.property_records?.assessed_value, lang)],
    ["sum.permits", (r) => r.summary?.permits?.value ?? "—"],
    ["sum.openPermits", (r) => r.summary?.open_permits?.value ?? "—"],
    ["sum.violations", (r) => (r.summary?.violations?.available ? r.summary.violations.value : t("sum.na"))],
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="compare-dialog" className="max-h-[85vh] max-w-3xl overflow-auto border-border">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl">{t("cmp.title")}</DialogTitle>
          <DialogDescription>{t("cmp.hint")}</DialogDescription>
        </DialogHeader>
        {reports.length === 2 ? (
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="border-b border-border text-left">
                <th className="py-2 pr-3" />
                {reports.map((r, i) => (
                  <th key={i} className="py-2 pr-3 font-serif text-base font-semibold text-foreground">
                    {(r.site_address || r.address || "").split(",")[0]}
                    <span className="block font-mono text-[10px] font-normal text-muted-foreground">{fmtFolio(r.folio)}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(([key, fn]) => (
                <tr key={key} className="border-b border-border/60 last:border-0">
                  <td className="py-2.5 pr-3 font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{t(key)}</td>
                  {reports.map((r, i) => (
                    <td key={i} className="py-2.5 pr-3 font-medium text-foreground">{fn(r)}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-sm text-muted-foreground">…</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
